"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGuaranteeValue = exports.GuaranteeTypes = exports.GuaranteeTypeEnum = void 0;
const ShopConfig_1 = require("../../common/utils/ShopConfig");
var GuaranteeTypeEnum;
(function (GuaranteeTypeEnum) {
    GuaranteeTypeEnum["CENTRAL_PERMISSION"] = "CENTRAL_PERMISSION";
    GuaranteeTypeEnum["NOKIAN_GUARANTEE_PLUS"] = "NOKIAN_GUARANTEE_PLUS";
})(GuaranteeTypeEnum = exports.GuaranteeTypeEnum || (exports.GuaranteeTypeEnum = {}));
exports.GuaranteeTypes = {
    CENTRAL_PERMISSION: {
        HUN: 'Központi engedéllyel',
        ROU: 'Solutionare MarsoRom',
        SRB: 'Sa dozvolom iz centrale'
    },
    NOKIAN_GUARANTEE_PLUS: {
        HUN: 'Nokian garancia plusz',
        ROU: 'Nokian garantie plus',
        SRB: 'Nokian dodatna garancija'
    }
};
const getGuaranteeValue = (guaranteeType) => {
    const shopLocation = ShopConfig_1.ShopConfig.getShopLocation();
    return exports.GuaranteeTypes[guaranteeType][shopLocation] || exports.GuaranteeTypes[guaranteeType]['HUN'];
};
exports.getGuaranteeValue = getGuaranteeValue;
